import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

import { Brand } from 'src/types/schema/graphql'

interface IBreadCrumbs {
    brewer: Brand
}

const BreadCrumbs: React.FC<IBreadCrumbs> = ({ brewer }) => {
    return (
        <div className='bdb-breadcrumbs hidden w-full border-b-px border-gray-100 py-3 md:block'>
            <div className='flex flex-col'>
                <UI.Breadcrumbs
                    customClasses='px-8 lg:px-20 text-sm font-semibold'
                    omitRootLabel={false}
                    customBreadcrumbs={[
                        {
                            breadcrumb: brewer.displayTitle || brewer.title,
                            href: `/brewer/${brewer.displayTitle || brewer.title || ''}`,
                        },
                    ]}
                />
            </div>
        </div>
    )
}

export default BreadCrumbs
